import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-3" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  class: "demo",
  id: "tableflame"
}
const _hoisted_6 = {
  class: "table table-sm m-0 tableClaim",
  id: "tableDailyReport",
  style: {"border-right":"1px #ccc solid"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Mo_dailyReport_row = _resolveComponent("Mo_dailyReport_row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRow())),
          disabled: _ctx.btnDisable
        }, " 行追加 ", 8, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-sm btn-primary waves-effect waves-themed mr-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.delRow())),
          disabled: _ctx.btnDisable
        }, " 行削除 ", 8, _hoisted_4)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-auto ml-md-auto" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("thead", { class: "bg-fusion-50" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "fixhead headReport cwC_1" }, [
              _createTextVNode(" 種別"),
              _createElementVNode("br"),
              _createTextVNode("（決定、提案、調査） ")
            ]),
            _createElementVNode("th", { class: "fixhead headReport cwC_2" }, "案件名"),
            _createElementVNode("th", { class: "fixhead headReport cwC_3" }, "商談先"),
            _createElementVNode("th", { class: "fixhead headReport cwC_4" }, "場所"),
            _createElementVNode("th", { class: "fixhead headReport cwC_5" }, "内容"),
            _createElementVNode("th", { class: "fixhead headReport cwC_6" }, "売上"),
            _createElementVNode("th", { class: "fixhead headReport cwC_7" }, "仕入")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createBlock(_component_Mo_dailyReport_row, {
              key: item.c_report_det_rownum!,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}